// extracted by mini-css-extract-plugin
export default {"root":"BRvfJVaYczoHt_JgPcbK","cellQuestionTextColumn":"w9ToWWhpSVnirg6KKi0q","cellAnswerTextColumn":"BZB1rlxj2ms6WL6ckCd_"};